module.exports = __webpack_public_path__ + "img/叶会华.ff5a7d86.jpg";